import React, { useContext } from 'react'
import { Button, Dialog } from 'components/ui'
import { AppSumoContext } from 'contexts/AppSumoContext'
import { Trans } from 'react-i18next'
import capitalize from 'components/ui/utils/capitalize'

const TIER_NAMES = {
    1: 'Tier 1',
    2: 'Tier 2',
    3: 'Tier 3',
}

const AppSumoLicenseModal = () => {

    const { setShowAppSumoLicenseModal, getLicenseTier } = useContext(AppSumoContext)
    const tier = getLicenseTier()
    const tierName = TIER_NAMES[tier] || `Tier ${tier}`

    return (
        <Dialog
            isOpen={true}
            closable={true}
            onClose={() => setShowAppSumoLicenseModal(false)}
            onRequestClose={() => setShowAppSumoLicenseModal(false)}
            overlayClassName="flex w-full h-full items-center justify-center"
            width={500}
        >
            <img src="/img/others/appsumo-banner.jpg" className='object-fit object-center object-cover w-[120%] max-w-none h-[150px] -mt-6 -mx-[10%] !mb-12' />
            <div className='flex flex-col gap-8 mb-12'>
                <div className='flex flex-col gap-8'>
                    <h1 className='text-tertiary-900 dark:text-white mega-title text-center'>
                        <Trans i18nKey="appSumo.congratulations">Congratulations!</Trans>
                    </h1>
                    <p className='text-center text-lg'>
                        <Trans i18nKey="appSumo.licenseActivatedText">
                            Your AppSumo license has been activated. You can now enjoy all the benefits of our {tierName} Plan for life — including all premium AI models!
                        </Trans>
                    </p>
                </div>
            </div>

            <div className='flex justify-end gap-2 p-4 -m-6 w-auto mt-10 border-t border-tertiary-100 dark:border-gray-700'>
                <Button variant="solid" onClick={() => setShowAppSumoLicenseModal(false)}>
                    <Trans i18nKey="appSumo.continue">Continue</Trans>
                </Button>
            </div>
        </Dialog>
    )
}

export default AppSumoLicenseModal
